<template>
  <div>
  <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h2 class="card-title">Midi Mosiac</h2>
              <p class="category">*An Interactive Art Exihibt*</p>
            </div>
            <div class="card-content">
              <img src="../../../../../static/img/IMG_3551.jpg" alt="A person in front of an interactive MIDI Controller" style="border-radius:30px;margin-bottom:20px">
              <p>The Midi Mosaic is an interactive art exhibit for a children’s museum that doubles as an interactive MIDI controller via capacitive touch photographs.</p>
              <p>The Midi Mosaic is currently located at the Curious Kids' Museum in St. Joseph, Michigan. Be sure to check it out if you get the chance! &#128513;</p>
            </div>
          </div>
        </div>
  </div>
  <!-- YouTube Demos -->
  <div class="row">
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Harder Better Faster Stronger Demo</h4>
            </div>
            <div class="card-content">
              <youtube :video-id="videoIdOne" ref="youtube" @playing="playing"></youtube>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Madeon Demo</h4>
            </div>
            <div class="card-content">
              <youtube :video-id="videoIdTwo" ref="youtube" @playing="playing"></youtube>
            </div>
          </div>
        </div>
  </div>

  <!-- Demo Stuff -->
  <div class="row">
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Built With</h4>
            </div>
            <div class="card-content">
              <ul style="font-size:15px">
                <li>[Teensy 3.6] - The microcontroller used</li>
                <li>[BlueSMiRF Silver] - The Bluetooth Modem used</li>
                <li>[Indium Tin Oxide Coated PET] – Used to create a capacitive glass</li>
                <li>[WS2812B RGB 5050 LED Strip] – LED strips for each of the boxes</li>
                <li>[RSP-320-5 300W 5V Power Supply] – Supplies power to this baby</li>
                <li>[MPR 121 Cap Touch Module] – Converts the user’s “touch” into a trigger in the software</li>
                <li>[TXB0108 Level Converter] – Take 3.3V to 5V and vice versa</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">CAD Model</h4>
            </div>
            <div class="card-content">
              <p>If anyone is interested, I used OnShape to sketch everything in CAD. The model can be found <a href="https://cad.onshape.com/documents/8cc8a91fe985116ffbdf6bbd/w/6f97be81eeae7664b89baed9/e/5e68668bd3000bb2f4dac299" target="_blank">here.</a></p>
            </div>
            <div class="card-header">
              <h4 class="card-title">Programming Lights</h4>
            </div>
            <div class="card-content">
             <p>
               I created a little web app in order to program all the lights (because generative programming definitely needed to happen with the sheer number of lights used in this project). You can play around with the web app <a href="https://mclemcrew.github.io/LED-Code-Generator-for-Midi-Mosaic/" target="_blank">here</a> and as always, the code for the web app is open source and can be found <a href="https://github.com/mclemcrew/LED-Code-Generator-for-Midi-Mosaic" target="_blank">here.</a>
             </p>
            </div>
          </div>
        </div>
    </div>

    <!-- Gallery -->
    <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Gallery</h4>
            </div>
            <div class="card-content" style="display: flex;
                  flex-flow: row wrap;
                  justify-content: center;">
              <!-- Image Gallery -->
              <gallery :images="images" :index="index" @close="index = null"></gallery>
              <div
                class="image"
                v-for="(image, imageIndex) in images"
                :key="imageIndex"
                @click="index = imageIndex"
                :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
              ></div>
            </div>
          </div>
        </div>
    </div>

  </div>
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  data () {
    return {
      videoIdOne: 'ryv_76FB_y8',
      videoIdTwo: 'lzz4zSDs-3s',
      images: [
        '../../../../../static/img/MidiMosaic/1.jpg',
        '../../../../../static/img/MidiMosaic/2.jpg',
        '../../../../../static/img/MidiMosaic/3.jpg',
        '../../../../../static/img/MidiMosaic/4.jpg',
        '../../../../../static/img/MidiMosaic/5.jpg',
        '../../../../../static/img/MidiMosaic/6.jpg',
        '../../../../../static/img/MidiMosaic/7.jpg',
        '../../../../../static/img/MidiMosaic/8.jpg',
        '../../../../../static/img/MidiMosaic/9.jpg',
        '../../../../../static/img/MidiMosaic/10.jpg',
        '../../../../../static/img/MidiMosaic/11.jpg',
        '../../../../../static/img/MidiMosaic/12.jpg',
        '../../../../../static/img/MidiMosaic/13.jpg',
        '../../../../../static/img/MidiMosaic/14.jpg'
      ],
      index: null
    }
  },
  methods: {
    playVideo () {
      this.player.playVideo()
    },
    playing () {
      console.log('/\\o/ we are watching!!!')
    }
  },
  computed: {
    player () {
      return this.$refs.youtube.player
    }
  },
  components: {
    'gallery': VueGallery
  }
}
</script>
<style>
iframe {
  width: 100%;
  max-width: 650px; /* Also helpful. Optional. */
}
.image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Projects/MidiMosaic.vue